<script setup lang="ts">
import { computed, useId } from 'vue'
const props = defineProps<{ modelValue: string; label: string }>()
const emit = defineEmits<{ 'update:modelValue': [value: string] }>()
const id = useId()
const colors = [
  '#ffffff',
  '#f1f5f9',
  '#e8f4ee',
  '#e5ecff',
  '#ffe9e0',
  '#e9d5ff',
  '#1e293b',
  '#111827',
]
const valid = computed(() => /^#[\da-f]{6}$/i.test(props.modelValue))
</script>
<template>
  <div>
    <label :for="id" class="field-label">{{ label }}</label>
    <div class="relative">
      <span
        class="absolute left-3 top-3 size-5 rounded-md border border-slate-200"
        :style="{ backgroundColor: valid ? modelValue : '#ffffff' }"
      />
      <input
        :id="id"
        :value="modelValue"
        class="field pl-11 font-mono"
        type="text"
        maxlength="7"
        pattern="#[0-9a-fA-F]{6}"
        :aria-invalid="!valid"
        autocomplete="off"
        spellcheck="false"
        @input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      />
    </div>
    <div class="mt-2 flex flex-wrap gap-1.5" role="group" :aria-label="label">
      <button
        v-for="color in colors"
        :key="color"
        type="button"
        class="size-6 rounded-md border border-slate-200 transition hover:scale-110"
        :style="{ backgroundColor: color }"
        :aria-label="`${label} ${color}`"
        :aria-pressed="modelValue.toLowerCase() === color"
        :class="modelValue.toLowerCase() === color ? 'ring-2 ring-moss-500 ring-offset-1' : ''"
        @click="emit('update:modelValue', color)"
      />
    </div>
  </div>
</template>
